export default {
  "base": "border-s-4 border-accented ps-4 italic"
}